import React, { Component } from 'react';
import style from './style/forwardcoaching.scss';

export default class ForwardCoaching extends Component {
    render() {
        const { title, text, linkText, link } = this.props;

        return (<div className={ style.forwardcoaching }>
            <h3>{ title }</h3>
            <p>{ text }</p>
            <a href={ link } target="_blank" className={ style.link }>
                <button className={ style.forwardcoaching_button }>{ linkText }</button>
            </a>
        </div>);
    }
}
